import type {
  MaskitoOptions,
  MaskitoPostprocessor,
  MaskitoPreprocessor,
} from '@maskito/core';
import { maskitoCaretGuard } from '@maskito/kit';

export function identity<T>(x: T): T {
  return x;
}

export function maskitoPrefixPostprocessorGenerator(
  prefix: string
): MaskitoPostprocessor {
  return prefix
    ? ({ value, selection }, initialElementState) => {
        if (value === prefix) {
          return { value: '', selection: [0, 0] };
        }

        if (
          value.startsWith(prefix) ||
          (!value && !initialElementState.value.startsWith(prefix))
        ) {
          return { value, selection };
        }

        const [from, to] = selection;
        const requiredPrefix = Array.from(prefix).reduce(
          (computedPrefix, char, i) => {
            const newValue = computedPrefix + value;
            return newValue[i] === char
              ? computedPrefix
              : computedPrefix + char;
          },
          ''
        );

        return {
          selection: [from + requiredPrefix.length, to + requiredPrefix.length],
          value: requiredPrefix + value,
        };
      }
    : identity;
}

function createCompletePhoneInsertionPreprocessor(): MaskitoPreprocessor {
  const trimPrefix = (value: string): string =>
    value.replace(/^(\+?7?\s?8?)\s?/, '');
  const countDigits = (value: string): number =>
    value.replace(/\D/g, '').length;

  return ({ elementState, data }) => {
    const { value, selection } = elementState;

    return {
      elementState: {
        selection,
        value: countDigits(value) > 11 ? trimPrefix(value) : value,
      },
      data: countDigits(data) >= 11 ? trimPrefix(data) : data,
    };
  };
}

const phoneMask: MaskitoOptions = {
  overwriteMode: 'shift',
  mask: [
    '+',
    '7',
    ' ',
    /[01234569]/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
  ],
  postprocessors: [maskitoPrefixPostprocessorGenerator('+7 ')],
  preprocessors: [createCompletePhoneInsertionPreprocessor()],
  plugins: [
    maskitoCaretGuard((value, [from, to]) => [
      from === to ? '+7 '.length : 0,
      value.length,
    ]),
  ],
};

export default phoneMask;
